import { apiFetchJson, apiPost } from './api';

/**
 * List all configurations for an integration
 * @param {string} integrationId - Integration UUID
 * @returns {Promise<Array>} Array of configuration objects
 */
export async function listConfigurations(integrationId) {
  return apiFetchJson(`/api/data-loads/integrations/${integrationId}/configurations/`);
}

/**
 * Save a configuration (draft)
 * @param {string} integrationId - Integration UUID
 * @param {Object} configurationData - Configuration data to save
 * @returns {Promise<Object>} Saved configuration object
 */
export async function saveConfiguration(integrationId, configurationData) {
  return apiPost(
    `/api/data-loads/integrations/${integrationId}/configurations/save/`,
    { configuration_data: configurationData }
  );
}

/**
 * Deploy a configuration (make it active)
 * @param {string} integrationId - Integration UUID
 * @param {Object} configurationData - Configuration data to deploy
 * @returns {Promise<Object>} Deployed configuration object
 */
export async function deployConfiguration(integrationId, configurationData) {
  return apiPost(
    `/api/data-loads/integrations/${integrationId}/configurations/deploy/`,
    { configuration_data: configurationData }
  );
}

/**
 * Schedule a deployment for a future time
 * @param {string} integrationId - Integration UUID
 * @param {string} scheduledAt - ISO datetime string for when to deploy
 * @returns {Promise<Object>} Scheduled deployment object
 */
export async function scheduleDeployment(integrationId, scheduledAt) {
  return apiPost(
    `/api/data-loads/integrations/${integrationId}/configurations/schedule/`,
    { scheduled_at: scheduledAt }
  );
}

/**
 * Cancel a scheduled deployment
 * @param {string} integrationId - Integration UUID
 * @returns {Promise<Object>} Cancellation confirmation
 */
export async function cancelScheduledDeployment(integrationId) {
  return apiPost(
    `/api/data-loads/integrations/${integrationId}/configurations/cancel-schedule/`,
    {}
  );
}
